// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as ApiUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as PlaceOrderRepoManager from "../repo/PlaceOrderRepoManager.bs.js";
import * as TicketingOrderRepoManager from "../../../order-dashboard/app/order/repo/order/TicketingOrderRepoManager.bs.js";

function fetchLocationBounds(geo_region_id, country, onSuccess, onFailure) {
  var RepoInstance = PlaceOrderRepoManager.getRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._2(RepoInstance.fetchLocationBounds, geo_region_id, country);
              }), Curry.__1(onSuccess), Curry.__1(onFailure));
}

function fetchRestrictionBounds(geo_region_id, country, onSuccess, onFailure) {
  var RepoInstance = PlaceOrderRepoManager.getRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._2(RepoInstance.fetchRestrictionBounds, geo_region_id, country);
              }), Curry.__1(onSuccess), Curry.__1(onFailure));
}

function fetchVehicleDetails(geo_region_id, latLng, mobile, country, onSuccess, onFailure) {
  var RepoInstance = PlaceOrderRepoManager.getRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._4(RepoInstance.fetchVehicleDetails, geo_region_id, latLng, mobile, country);
              }), Curry.__1(onSuccess), Curry.__1(onFailure));
}

function fetchVehicleQuotation(payload, country, onSuccess, onFailure) {
  var RepoInstance = PlaceOrderRepoManager.getRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._2(RepoInstance.fetchVehicleQuotation, payload, country);
              }), Curry.__1(onSuccess), Curry.__1(onFailure));
}

function fetchCouponList(geo_region_id, pickupLatLng, dropLatLng, customer_id, order_id, country, onSuccess, onFailure) {
  var RepoInstance = PlaceOrderRepoManager.getRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._6(RepoInstance.fetchCouponList, geo_region_id, pickupLatLng, dropLatLng, customer_id, country, order_id);
              }), Curry.__1(onSuccess), Curry.__1(onFailure));
}

function placeOrder(payload, country, onSuccess, onFailure) {
  var RepoInstance = PlaceOrderRepoManager.getRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._2(RepoInstance.placeOrder, payload, country);
              }), Curry.__1(onSuccess), Curry.__1(onFailure));
}

function applyCoupon(payload, country, onSuccess, onFailure) {
  var RepoInstance = PlaceOrderRepoManager.getRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._2(RepoInstance.applyCoupon, payload, country);
              }), Curry.__1(onSuccess), Curry.__1(onFailure));
}

function removeCoupon(payload, country, onSuccess, onFailure) {
  var RepoInstance = PlaceOrderRepoManager.getRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._2(RepoInstance.removeCoupon, payload, country);
              }), Curry.__1(onSuccess), Curry.__1(onFailure));
}

function fetchOrder(order_id, country, onSuccess, onFailure) {
  var RepoInstance = TicketingOrderRepoManager.getTicketingOrderRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._2(RepoInstance.fetchOrder, order_id, country);
              }), Curry.__1(onSuccess), Curry.__1(onFailure));
}

export {
  fetchLocationBounds ,
  fetchRestrictionBounds ,
  fetchVehicleDetails ,
  fetchVehicleQuotation ,
  fetchCouponList ,
  placeOrder ,
  applyCoupon ,
  removeCoupon ,
  fetchOrder ,
  
}
/* PlaceOrderRepoManager Not a pure module */
